import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { IonicModule, PopoverController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ioc-selector',
  templateUrl: './ioc-selector.component.html',
  styleUrls: ['./ioc-selector.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule
  ],
})
export class IocSelectorComponent {
  private popoverController = inject(PopoverController);

  @Input({ required: true}) title: string;
  @Input({ required: true }) iocSelectorOptions: { label: string, value: any }[];
  @Input() showCancelButton = false;

  constructor() { }

  close(event) {
    this.popoverController.dismiss(event.detail.value);
  }

  cancel() {
    this.popoverController.dismiss({ isCanceled: true });
  }

}
